import { useState, useEffect } from 'react';

/**
 * [SEC-2026-06] Read-only mode hook.
 *
 * Returns true when the school's subscription is expired/suspended. The flag is
 * set by the global axios response interceptor in App.js the moment the backend
 * answers a mutation with 403 {code:"SUBSCRIPTION_REQUIRED"}. Components use this
 * to disable Add/Create/Submit/Record actions while leaving reads alone.
 */
export function useReadOnlyMode() {
  const [isReadOnly, setIsReadOnly] = useState(
    typeof window !== 'undefined' && window.__readOnlyMode === true
  );

  useEffect(() => {
    const handler = () => setIsReadOnly(window.__readOnlyMode === true);
    window.addEventListener('subscription_status_changed', handler);
    return () => window.removeEventListener('subscription_status_changed', handler);
  }, []);

  return isReadOnly;
}

export default useReadOnlyMode;
